import React from 'react'
import { Switch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'
import SignUp from '../pages/Auth/SignUp'
import SignIn from '../pages/Auth/SignIn'
import ForgotPassword from '../pages/Auth/ForgotPassword'
import ResetPassword from '../pages/Auth/ResetPassword'

const AuthWrapper = ({ match, location }) => {
    const { path } = match
    const { pathname } = location
    return (
        <Switch>
            <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
            <Route path={`${path}/sign-up`} component={SignUp} />
            <Route path={`${path}/sign-in`} component={SignIn} />
            <Route
                path={`${path}/forgot-password`}
                component={ForgotPassword}
            />
            <Route path={`${path}/reset-password`} component={ResetPassword} />
        </Switch>
    )
}

export default AuthWrapper
